import React from "react"
import classes from "./Input.module.css"

const input = (props) => {
    let inputElement = null
    const inputClasses = [classes.InputElement]
    if (props.inValid && props.touched && props.shouldValidate) {
        inputClasses.push(classes.Invalid)
    }
    switch (props.elementType) {
        case "input":
            inputElement = <input className={inputClasses.join(" ")} value={props.value} onChange={props.changed} {...props.elementConfig} />
            break;
        case "textArea":
            inputElement = <textarea className={inputClasses.join(" ")} value={props.value} onChange={props.changed} {...props.elementConfig} />
            break;
        case "select":
            inputElement = (
                <select className={inputClasses.join(" ")} value={props.value} onChange={props.changed}>
                    {props.elementConfig.options.map(option => {
                        return (
                            <option key={option.value} value={option.value}>
                                {option.displayValue}
                            </option>
                        )
                    })}
                </select>
            )
            break;
        default:
            inputElement = <input className={inputClasses.join(" ")} value={props.value} onChange={props.changed} {...props.elementConfig} />
            break;
    }
    return (
        <div className={classes.Input}>
            <label className={classes.Label}>
                {props.label}
            </label>
            {inputElement}
        </div>
    )
}

export default input